module.exports = __webpack_public_path__ + "img/icon-back.18d63379.svg";